<doka-modal-wrapper (close)="closeModal()">
  <ng-template #title>
    {{ "MasterData.EditCatalogCategoryModal.Title" | i18nextEager }}
  </ng-template>
  <ng-template #content>
    <form [formGroup]="form">
      <div class="flex flex-col gap-lg w-full">
        @for (group of nameTranslations.controls; track group.controls.languageCode.value) {
          <div [formGroup]="group">
            <doka-text-field
              [frontDecoText]="group.controls.languageCode.value.toUpperCase()"
              formControlName="value"
              [label]="'MasterData.EditCatalogCategoryModal.Name' | i18nextEager"
              [placeholder]="'Common.Placeholder' | i18nextEager"
            />
          </div>
        }
      </div>
    </form>
  </ng-template>
  <ng-template #footer>
    <div class="flex flex-col gap-sm w-full">
      <div class="flex w-full gap-md px-6 pt-4 items-center justify-end">
        <doka-button [disabled]="isLoading()" (click)="closeModal()" color="secondary">{{
          "Common.Cancel" | i18nextEager
        }}</doka-button>
        <doka-button
          type="submit"
          [disabled]="form.invalid || isLoading() || nameTranslations.length === 0"
          (click)="submit()"
          color="primary"
        >
          {{ "Common.Save" | i18nextEager }}
        </doka-button>
      </div>
    </div>
  </ng-template>
</doka-modal-wrapper>
